/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerStreamQueryResponse, IncidentInvestigationControllerStreamPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerStream";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerStream } from "../../clients/incident-agentService/incidentInvestigationControllerStream";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerStreamQueryKey = (id: IncidentInvestigationControllerStreamPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/stream',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerStreamQueryKey = ReturnType<typeof incidentInvestigationControllerStreamQueryKey>;
export function incidentInvestigationControllerStreamQueryOptions(id: IncidentInvestigationControllerStreamPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerStreamQueryKey(id);
  return queryOptions<IncidentInvestigationControllerStreamQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerStreamQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerStream(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/stream}
 */
export function useIncidentInvestigationControllerStream<TData = IncidentInvestigationControllerStreamQueryResponse, TQueryData = IncidentInvestigationControllerStreamQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerStreamQueryKey>(id: IncidentInvestigationControllerStreamPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerStreamQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerStreamQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerStreamQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}